import { useTeaseNotifications } from '../../../RealTimeNotificationHandlers/hooks';
import useTeaseAlerts from './useTeaseAlerts';
import { useMemo } from 'react';
export const useNotificationsWithAlerts = () => {
  const notifications = useTeaseNotifications();
  const alerts = useTeaseAlerts();
  return useMemo(() => {
    // Alerts that no longer have an associated notification showing, will be sorted via timestamp only
    const strayAlerts = alerts.filter(alert => notifications.every(notification => notification.id !== alert.id)).sort((a, b) => a.createdAt - b.createdAt);
    const removeAlertsBefore = timestamp => {
      const index = strayAlerts.findIndex(alert => alert.createdAt >= timestamp);
      if (index === -1) {
        // All items are before the timestamp
        return strayAlerts.splice(0, strayAlerts.length);
      }
      // Remove items before the timestamp and return them
      return strayAlerts.splice(0, index);
    };
    const notificationAndAlertsInOrder = notifications.reduce((acc, notification) => {
      const alertsBeforeThisNotification = removeAlertsBefore(notification.createdAt);
      const prevAlertsAndThisNotification = [/* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
      ...acc, ...alertsBeforeThisNotification, notification];
      const alertForThisNotification = alerts.find(alert => alert.id === notification.id);
      return alertForThisNotification ? [...prevAlertsAndThisNotification, alertForThisNotification] : prevAlertsAndThisNotification;
    }, []);
    return [...notificationAndAlertsInOrder, ...strayAlerts];
  }, [alerts, notifications]);
};